module.exports = __webpack_public_path__ + "img/hsbc.93646fff.png";